import {rqCreateRequest, rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {
  RQ_GET_EXPENCE_LIST_BY_YEAR_MONTH_API,
  RQ_POST_UNLOCK_EXPENCE_BY_EMPLOYEE_CODE_YEAR_MONTH_API,
} from '@app/reactQuery/apis/constants/rqUnlockExpenceAPIConstant';
import {useQuery} from '@tanstack/react-query';

export const RQPOSTUnlockExpenceByEmployeeCodeAndYearMonth = async ({
  certificate,
  signal,
  employeeCode,
  yyyyMm,
}) => {
  return rqCreateRequest(
    RQ_POST_UNLOCK_EXPENCE_BY_EMPLOYEE_CODE_YEAR_MONTH_API,
    null,
    certificate,
    {employeeCode: employeeCode, yyyyMm:yyyyMm},
    signal,
  );
};

export const RQUseGetExpenceListByYearMonth = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_expence_list_by_year_month', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, yyyyMm} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_EXPENCE_LIST_BY_YEAR_MONTH_API,
        null,
        certificate,
        {yyyyMm: yyyyMm},
        signal,
      );
    },
    ...options,
  });
};
